export default "__VITE_ASSET__D5OsLbjE__"